import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { Grid, IconButton, ListItem, ListItemText, styled } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { WsColors } from 'wisestep-base';

import { SettingsPageLayout } from '../../../components/SettingsPageLayout';
import { ISettingsMenuOption } from '../../../features/appsettings';
import {
  getSettingBreadCrumbList,
  ISettingBreadCrumbTypes,
  Pages,
} from '../../../features/teams/helper/defaultValues';

const SettingsMenuItem = styled(ListItem)(({ theme }) => ({
  cursor: 'pointer',
  height: '100%',
  minHeight: 80,
  border: '2px solid' + WsColors.BorderGrey,
  borderRadius: theme.spacing(0.5),
  ':hover': {
    boxShadow: '1px 1px 5px' + WsColors.BorderGrey,
  },
}));

const BulkImporterApp = () => {
  const navigate = useNavigate();
  const bulkImporterOptions: ISettingsMenuOption[] = [
    {
      label: 'CV Uploader App (Ubuntu) 1.3.0',
      url: './',
      icon: (
        <IconButton
          onClick={() => {
            window.open(
              'https://wisestep-open.s3.eu-west-1.amazonaws.com/wisestep_1.3.0_amd64.deb',
              '_blank'
            );
          }}
        >
          <FileDownloadOutlinedIcon sx={{ fill: WsColors.TheBlues500, cursor: 'pointer' }} />
        </IconButton>
      ),
    },
    {
      label: 'CV Uploader App (Windows) 1.3.0',
      url: './',
      icon: (
        <IconButton
          onClick={() => {
            window.open(
              'https://wisestep-open.s3.eu-west-1.amazonaws.com/wisestep_1.3.0.exe',
              '_blank'
            );
          }}
        >
          <FileDownloadOutlinedIcon sx={{ fill: WsColors.TheBlues500, cursor: 'pointer' }} />
        </IconButton>
      ),
    },
  ];
  return (
    <SettingsPageLayout
      title="CV Uploader App"
      indexOptions={[{ label: 'CV Uploader App', url: '' }]}
      breadCrumnbsList={getSettingBreadCrumbList(
        ISettingBreadCrumbTypes.APPS_AND_INTEGRATION,
        Pages['CV_UPLOADER_APP']
      )}
    >
      <Grid p={2}>
        <Grid container rowGap={2} columnSpacing={2}>
          {bulkImporterOptions.map((option, i) => (
            <Grid key={i} item xs={6}>
              <SettingsMenuItem
                onClick={() => {
                  option?.openInNewTab ? window.open(option.url, '_blank') : navigate(option.url);
                }}
              >
                <ListItemText
                  primaryTypographyProps={{ fontWeight: 700 }}
                  primary={option.label}
                  secondary={option.description}
                />
                {option.icon && option.icon}
              </SettingsMenuItem>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </SettingsPageLayout>
  );
};

export default BulkImporterApp;
